import { render, staticRenderFns } from "./step2main.vue?vue&type=template&id=609f05e8"
import script from "./step2main.vue?vue&type=script&lang=js"
export * from "./step2main.vue?vue&type=script&lang=js"
import style0 from "./step2main.vue?vue&type=style&index=0&id=609f05e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports